import { useCallback, useState } from "react";
import { strtoInt } from "../util/libString";
import { searchCep } from "../util/libSearchCep";
import LibMask from "../util/mask";

export const useAddress = (setValue, setFocus, getValues) => {
	const [cepIsSubmitting, setCepIsSubmitting] = useState(false);

	const handleSetDataCep = useCallback(
		(data) => {
			const uf = data.uf.toUpperCase();
			const ibge = strtoInt(data.ibge);
			setValue("uf", uf);
			setValue("rua", `${data.logradouro.toUpperCase()}`);
			setValue("bairro", data.bairro.toUpperCase());
			setValue("id_cidade", ibge);
			setFocus("numero");
		},
		[setValue, setFocus]
	);

	const handleFetchAddressByCep = useCallback(async () => {
		const cep = getValues("cep");
		validateCep(cep);
		try {
			setCepIsSubmitting(true);
			const response = await searchCep(cep);

			handleSetDataCep(response);

			return response.uf;
		} finally {
			setCepIsSubmitting(false);
		}
	}, [handleSetDataCep, getValues]);

	const validateCep = (cep) => {
		const validCep = LibMask.cep(cep);

		if (validCep.length !== 9) {
			throw new Error("Digite um CEP válido.");
		}
		return true;
	};

	return { handleFetchAddressByCep, cepIsSubmitting };
};
